export const en = {
  "common": {
    "brand": "Fyrrehaven 61",
    "bookNow": "Book on Airbnb",
    "sleepsX": "Sleeps {{count}} guests",
    "form": {
      "selectPlaceholder": "Choose",
      "chooseFile": "Choose file",
      "chooseFiles": "Choose files",
      "required": "This field is required",
      "emailMismatch": "Email and confirm email must match.",
      "fileAlreadyAdded": "This photo is already added. Remove it first if you want to choose another photo.",
      "maxFilesReached": "You can upload up to {{count}} meter photos.",
      "moreFileIssues": "{{count}} more issue needs attention."
    }
  },
  "home": {
    "heroTitle": "Family-friendly holiday home in the woods – near the beach",
    "heroSubtitle": "Pool, hot tub, sauna, activity room and room for everyone.",
    "ctaSeeHouse_da": "Se huset",
    "ctaSeeHouse_en": "See the house",
    "badgePool": "Outdoor heated pool",
    "badgeHotTub": "Hot tub",
    "badgeActivityRoom": "Activity room",
    "badgeBeach": "Near the beach",
    "altKitchen": "Bright kitchen-living area",
    "altPool": "Outdoor heated pool",
    "altHotTub": "Outdoor hot tub",
    "altBeach": "Fjellerup beach",
    "whyFamiliesTitle": "Why families love Fyrrehaven 61",
    "whyFamiliesSub": "Everything you need for a cosy getaway — nature right outside.",
    "featSleeps": "Sleeps {{count}} (bed layout & family gear)",
    "featPool": "Outdoor heated pool in season",
    "featHotTub": "Relaxing hot tub under the pines",
    "featActivityRoom": "Activity room with billiards, table tennis, air hockey, darts and projector",
    "featBeach": "Short walk to the beach & ice cream shop",
    "featForest": "Woodland area with playgrounds and trails",
    "featKids": "High chair, travel cot and family games",
    "featWifi": "Fast Wi-Fi for streaming and work",
    "featParking": "Free parking at the house",
    "reviewsTitle": "Guest reviews",
    "reviewsSub": "We link to Airbnb for all reviews.",
    "quote1": "Perfect for kids — they loved the pool!",
    "quote2": "Quiet area close to beach and forest.",
    "quote3": "Bright, clean and easy to book.",
    "seeMoreOnAirbnb": "See more on Airbnb",
    "mapTitle": "Fyrrehaven 61 on the map",
    "readyTitle": "Ready to book?",
    "readySub": "Check availability and pricing on Airbnb."
  },
  "reviews": {
    "ariaLabel": "Reviews",
    "title": "What guests say",
    "ratingLabel": "{{value}} out of 5",
    "scrollLeft": "Scroll left",
    "scrollRight": "Scroll right",
    "readMore": "Read full review",
    "showLess": "Show less",
    "emptyReview": "This guest left a star rating without written feedback.",
    "source": "Source",
    "airbnbCta": "See all reviews on Airbnb"
  },
  "book": {
    "hero": {
      "title": "Booking",
      "subtitle": "Send a direct request – or book via Airbnb if you prefer.",
      "badges": {
        "pool": "Heated outdoor pool (May–Oct)",
        "guests": "Sleeps 10 guests",
        "family": "Family friendly"
      },
      "airbnbCta": "Booking Airbnb",
      "imageAlt": "Book the holiday home in Fjellerup"
    },
    "intro": {
      "title": "How would you like to book?",
      "body": "You can either send us a direct request using the form below, or you can book via Airbnb if you prefer. We usually respond within 1 hour.",
      "noteTitle": "Good to know",
      "notePool": "Outdoor pool heated to ~29 °C and open May 1 – Oct 1. Max 10 guests. No parties.",
      "noteUtilities": "Electricity: 4 DKK/kWh, water: 80 DKK/m³ (settled after your stay)."
    },
    "process": {
      "title": "How the booking works",
      "lead": "It's a request, not an instant reservation. We'll quickly reply with either a rental agreement or a polite decline.",
      "aria": "Booking process",
      "steps": {
        "request": {
          "title": "Send a request",
          "body": "Pick your dates in the calendar and fill in the form below."
        },
        "review": {
          "title": "We review your request",
          "bodyIntro": "We check availability, party size and the purpose of your stay.",
          "bodyRules": "House rules: no parties and no youth-only groups under {{minAge}}. Max {{maxGuests}} guests."
        },
        "reply": {
          "title": "Our reply (usually within {{responseHours}} hours)",
          "bodyIntro": "You'll hear back from us (usually within {{responseHours}} hours).",
          "bodyDetails": "If everything checks out, we send a rental agreement with price and practical info. If the dates don't work—or the request breaks our house rules—we'll suggest alternatives or politely decline."
        },
        "confirm": {
          "title": "You sign – we confirm",
          "bodyIntro": "Your booking is confirmed once the rental agreement is signed and payments are received.",
          "bodyDetails": "After that you'll receive a welcome email with key info, address and arrival instructions."
        }
      },
      "note": {
        "label": "House rules, short:",
        "text": "no parties, no youth-only groups under {{minAge}}, and please respect the neighbours. Max {{maxGuests}} guests.",
        "readMore": "Read more here:",
        "fees": "fee list",
        "privacy": "privacy policy"
      }
    }
  },
  "area": {
    "attractions": {
      "djurs-sommerland": {
        "title": "Djurs Sommerland",
        "description": "Scandinavia’s largest amusement park with 60+ rides and water park."
      },
      "legerevet-grenaa": {
        "title": "Lege-revet (Grenaa) – indoor playland",
        "description": "Indoor playland: climbing frames, slides and ball pit."
      },
      "hermans-hule-grenaa": {
        "title": "Hermans Hule (Grenaa) – indoor playland",
        "description": "Large indoor playland with slides and trampolines."
      },
      "fjollehaven": {
        "title": "Fjollehaven",
        "description": "Large outdoor playland"
      },
      "fjellerup-strand": {
        "title": "Fjellerup Beach",
        "description": "Wide, family-friendly sandy beach within biking distance."
      },
      "mols-bjerge": {
        "title": "Mols Bjerge National Park",
        "description": "Hilly landscapes, great viewpoints and hiking trails."
      },
      "kalo-slotsruin": {
        "title": "Kalø Castle Ruin",
        "description": "Iconic castle ruin in Kalø Bay – scenic walk on the old stone road."
      },
      "kattegatcentret": {
        "title": "Kattegat Centre (Grenaa)",
        "description": "Aquarium with sharks and seals – perfect for windy/chilly days."
      },
      "randers-regnskov": {
        "title": "Randers Rainforest",
        "description": "Tropical domes with animals and plants – year-round."
      },
      "vaffelbageri": {
        "title": "Fjellerup Waffle Bakery",
        "description": "Famous waffles by the beach – seasonal opening."
      },
      "vaffelbageri-food": {
        "title": "Fjellerup Waffle Bakery - fast food",
        "description": "Ice cream and fast food – seasonal opening."
      },
      "vaffelhuset": {
        "title": "Vaffelhuset",
        "description": "Homemade ice cream – seasonal opening."
      },
      "brugsen-fjellerup": {
        "title": "Brugsen Fjellerup Strand",
        "description": "Local grocery store for everyday shopping."
      },
      "alt-til-dagen": {
        "title": "Alt Til Dagen",
        "description": "Local grocery store for everyday shopping."
      }
    }
  },
  "contact": {
    "hero": {
      "title": "Contact us",
      "subtitle": "We usually reply quickly — often within a few hours.",
      "badges": {
        "family": "Family-friendly",
        "beach": "Near the beach"
      },
      "imageAlt": "The family behind the house",
      "primaryCta": "Book directly",
      "secondaryCta": "Booking Airbnb"
    },
    "form": {
      "heading": "Send us a message",
      "submit": {
        "message": "Send message",
        "booking": "Send request",
        "sendingMessage": "Sending message...",
        "sendingBooking": "Sending request...",
        "aria": "Submit the form"
      },
      "success": {
        "messageTitle": "Thanks for your message!",
        "bookingTitle": "Thanks for your booking request!",
        "messageLead": "We'll get back to you as soon as possible. Here's a copy of what you sent:",
        "bookingLead": "We'll get back to you shortly. Here's a summary of your request:"
      }
    }
  },
  "fees": {
    "page": {
      "title": "Fees",
      "lead": "To ensure the best experience for all guests, we’ve listed fees that may apply in specific situations.",
      "infoTitle": "Important information for booking the holiday home",
      "badges": {
        "noParties": "No rentals for parties or groups under 25 years.",
        "noPets": "No pets allowed indoors.",
        "pool": "Outdoor pool open May 1 – October 1."
      },
      "consumptionTitle": "Consumption is settled after your stay",
      "consumptionElectricity": "Electricity and water consumption according to the rental agreement.",
      "consumptionExtras": "If extra services are ordered after booking, these will be charged.",
      "listTitle": "Fee list",
      "footer": "Note: Fees may be charged if terms are not met. Contact us if you have questions."
    },
    "items": {
      "early-checkin-unauthorized": {
        "title": "Early check-in without prior approval",
        "unit": "per commenced half-hour"
      },
      "late-checkout-unauthorized": {
        "title": "Late check-out without prior approval",
        "unit": "per commenced half-hour"
      },
      "hottub-over-42c": {
        "title": "Hot tub temperature exceeds 42°C",
        "note": "applies to the hot tub only"
      },
      "hottub-damage": {
        "title": "Damage to hot tub",
        "note": "Minimum fee – actual repair/replacement costs may be added."
      },
      "spa-tech-damage": {
        "title": "Damage to hot tub equipment (heat pump, water pump, etc.)",
        "note": "Minimum fee – actual repair/replacement costs may be added."
      },
      "grill-not-cleaned": {
        "title": "Barbecue not cleaned"
      },
      "trash-not-disposed": {
        "title": "Waste not disposed of",
        "note": "applies at check-out"
      },
      "dishwasher-not-emptied": {
        "title": "Dishwasher not emptied",
        "note": "applies at check-out"
      },
      "outdoor-furniture-not-returned": {
        "title": "Outdoor furniture not returned to place"
      },
      "loft-toys-not-tidied": {
        "title": "Loft and toys not tidied"
      },
      "doors-windows-not-locked": {
        "title": "Doors or windows not locked/closed"
      },
      "noise-complaints": {
        "title": "Noise disturbance or neighbour complaints"
      },
      "remotes-missing": {
        "title": "Missing remote controls",
        "unit": "per item"
      },
      "keys-missing": {
        "title": "Missing keys for house or pool cover",
        "unit": "per key"
      },
      "mattress-soiling": {
        "title": "Urine/liquids on beds and mattresses",
        "unit": "per mattress"
      },
      "indoor-smoking": {
        "title": "Smoking indoors (not permitted)"
      },
      "sauna-damage": {
        "title": "Damage to sauna (interior/panelling)",
        "note": "Minimum fee – actual repair/replacement costs may be added."
      },
      "sauna-stove-damage": {
        "title": "Damage to sauna stove",
        "note": "Minimum fee – actual costs may be added."
      },
      "pool-tech-damage": {
        "title": "Damage to pool equipment (pump, filter, heat pump, etc.)",
        "note": "Minimum fee – actual costs may be added."
      },
      "activity-table-damage": {
        "title": "Damage to 3-in-1 multi-game table",
        "note": "Minimum fee – actual repair/replacement costs may be added."
      },
      "dart-damage": {
        "title": "Damage to dartboard or safety pads",
        "note": "Minimum fee – actual repair/replacement costs may be added."
      }
    }
  },
  "extraServices": {
    "page": {
      "eyebrow": "Add-ons for your stay",
      "title": "Extra services",
      "lead": "We want to make your upcoming stay unforgettable, and therefore we offer a range of additional services. Please fill out the form to request these services.",
      "listAria": "List of extra services",
      "includedTitle": "Included in the rent",
      "includedText": "Tea towel - Dishcloth - Shampoo - Shower gel - Hand soap - Dish soap - Dishwasher powder - Coffee beans"
    },
    "form": {
      "yes": "Yes",
      "no": "No",
      "select": "Select",
      "free": "FREE",
      "total": "Estimated extra total",
      "submit": "Send request",
      "sending": "Sending request...",
      "success": "Thank you. Your extra service request has been sent.",
      "successFollowup": "We will arrange it and only contact you if something cannot be done.",
      "summaryYes": "The guest would like extra services.",
      "summaryNo": "The guest does not want extra services at this time.",
      "noSpecificItems": "No specific quantities selected.",
      "dateHint": "Extra services are normally requested at least 3 days before arrival, so we have time to prepare.",
      "lateNotice": "Late and last-minute requests are accepted. We will arrange it and only contact you if something cannot be done.",
      "bundleHint": "Complete package of bedding, sheets and towels",
      "fields": {
        "name": "Booker",
        "email": "Email Address",
        "confirmEmail": "Confirm email",
        "stayDate": "Date of stay",
        "wantsExtras": "Would you like our extra service?",
        "otherRequests": "Any other requests?"
      },
      "placeholders": {
        "name": "Name of the person who booked the stay",
        "email": "john@doe.com",
        "amount": "Desired amount",
        "otherRequests": "Write your requests here and we will find a solution"
      },
      "hints": {
        "high-chair": "One chair available",
        "baby-cot": "One baby cot available"
      },
      "calendar": {
        "previous": "Previous month",
        "next": "Next month"
      },
      "acceptBefore": "By checking this box, you confirm that you have made a decision regarding any extra services, consent to processing your request and have read and accepted our",
      "houseRules": "house rules",
      "and": "and",
      "feeList": "fee list",
      "acceptAfter": "for potential violations. The code for the key box will be sent 1 hour before arrival, once this is confirmed.",
      "errors": {
        "required": "Please fill in name, email, confirm email and date of stay.",
        "dateTooSoon": "Please choose today or a future arrival date.",
        "email": "Please enter a valid email address.",
        "emailMismatch": "Email and confirm email must match.",
        "dateNotBooked": "We cannot find a booking starting on that date. Please choose your booking start date.",
        "nameMismatch": "The name does not match the booking we found for that date. Please use the same name as on the booking.",
        "bookingCheckUnavailable": "We could not verify the booking calendar right now. Please try again shortly.",
        "bookingCheck": "We could not verify your booking details. Please check the name and date, then try again.",
        "noSelection": "Please select at least one extra service when you answer yes.",
        "tooManyPeople": "Bed linen, sheets, towels and bundles can only be ordered for up to 10 people in total.",
        "accept": "Please accept the house rules and fee list before submitting.",
        "rateLimited": "Too many requests were sent in a short time. Please wait a moment and try again.",
        "tooFast": "Please review the form once more and send it again in a moment.",
        "formExpired": "This form session has expired. Please reload the page and send the request again.",
        "security": "The request could not be accepted from this browser session. Please reload the page and try again.",
        "lateSubmit": "Your late request could not be sent automatically. Because your stay is soon, please contact us directly so we can arrange it.",
        "network": "The connection was interrupted before the request could be sent. Please check your internet connection and try again.",
        "lateNetwork": "The connection was interrupted before your late request could be sent. Because your stay is soon, please contact us directly if it does not go through.",
        "submit": "Could not send your request. Please try again shortly."
      }
    }
  },
  "guest": {
    "accordion": {
      "pool": {
        "duckkey": "Pool cover key",
        "keyhole": "Keyhole for pool cover"
      },
      "spa": {
        "rules": {
          "title": "Rules and usage",
          "note": "Note!",
          "intro": "You must not bring your own firewood for the hot tub as it is heated electrically. The tub is clean and ready at arrival.",
          "maxTemp": "Max temperature is 40°C.",
          "buttons": "There are two buttons on the side of the hot tub",
          "button1": "Button 1 — Light",
          "button2": "Button 2 — Massage/bubbles",
          "dial": "Adjust intensity with the dial",
          "waterLevel": "Water level must not exceed the top nozzles",
          "massageTemp": "Do not activate massage before water is above 20°C",
          "firewood": "The hot tub is electrically heated; do not use firewood.",
          "chlorine": "Chlorine tablets are used to keep the water clean",
          "drain": "Guests are not required to drain the hot tub after their stay.",
          "imageAlt": "Hot tub",
          "caption": "Use of the hot tub is at your own risk."
        },
        "fire": {
          "title": "How to heat the hot tub",
          "fill": "Fill the tub with the garden hose – this takes about 2 hours.",
          "heater": "When water is 10 cm above the heater hole, you can light the fire and add 2 chlorine tabs.",
          "smoke": "Use dry firewood and get a proper flame to avoid heavy smoke from chimney.",
          "wood": "Fill approx. 2/3 of the heater with wood",
          "cover": "Place the thermal cover and be patient",
          "stopWood": "Once water reaches ~36°C, stop adding firewood.",
          "temp": "Check water temperature before use – ideal range is 36–40°C",
          "close": "After use, close the cover and drain the tub."
        }
      },
      "sauna": {
        "rules": {
          "title": "Rules and usage",
          "lightTitle": "Turn on the light",
          "light": "Outside the sauna, there’s a switch for both indoor and outdoor lights.",
          "heaterTitle": "Set the heater",
          "heater": "Inside the sauna, at the bottom of the heater – you’ll find two control knobs:",
          "leftTitle": "Left knob: Temperature",
          "left": "Set your preferred heat (recommended 70–80°C).",
          "rightTitle": "Right knob: Time",
          "right": "Turn to start the sauna. Past '0' activates delayed timer; within first section starts immediately.",
          "waitTitle": "Wait for heating",
          "wait": "The sauna will be ready after about 30–45 minutes.",
          "showerTitle": "Shower before entering",
          "shower": "Wash and dry off – improves hygiene and heat absorption.",
          "towelTitle": "Use a towel",
          "towel": "Always sit on a towel – including under your feet.",
          "durationTitle": "Enjoy the sauna for 10–15 minutes at a time",
          "duration": "Listen to your body. Take breaks and drink plenty of water.",
          "coolTitle": "Cool down afterwards",
          "cool": "Take a shower or go outside – boosts your well-being."
        },
        "donts": {
          "title": "What You Must Not Do",
          "waterTitle": "Do not pour large amounts of water on the heater",
          "water": "A small amount is fine. Too much may damage the heater or trip the safety system.",
          "alcoholTitle": "Do not drink alcohol before or during use",
          "alcohol": "Alcohol is strictly prohibited – it can be life-threatening in high heat.",
          "foodTitle": "Do not bring food or drinks",
          "childrenTitle": "No unsupervised children",
          "children": "Only short use and always under adult supervision.",
          "oilsTitle": "Do not use essential oils or similar products",
          "oils": "They can damage the heater and cause allergic reactions."
        },
        "safety": {
          "title": "Important Safety",
          "off": "Always turn off the sauna after use – set the right knob (time) to '0'.",
          "health": "Do not use the sauna if you are ill, pregnant, or have a pacemaker.",
          "storage": "Never use the sauna as storage.",
          "air": "Keep air inlets and outlets around the heater clear.",
          "leave": "Leave immediately if you feel dizzy or unwell.",
          "water": "Drink water before and after to prevent dehydration."
        }
      },
      "manual": {
        "during": {
          "wifi": {
            "title": "Wi-Fi",
            "name": "Name: HabibiHytten",
            "password": "Password: Dolma3000",
            "speed": "Speed: up to 1000/1000 Mbit",
            "coverage": "Coverage throughout the house and outside"
          },
          "espresso": {
            "title": "Espresso machine",
            "beans": "Coffee beans included.",
            "clean": "Press start after each coffee to clean.",
            "empty": "Empty wastewater and refill with clean water regularly."
          },
          "foldingDoor": {
            "title": "Folding door",
            "body": "The large door to the pool can be opened in 5 parts. Open slowly and carefully. You're responsible if it breaks."
          },
          "access": {
            "title": "No access",
            "shed": "Tool shed",
            "annex": "Annex",
            "activityRoomTechnical": "Locked technical area in the activity room"
          },
          "smoking": {
            "title": "Smoking",
            "body": "No smoking indoors or on the covered terrace. Please smoke outside."
          },
          "pool": {
            "title": "Pool",
            "body": "Open during summer period"
          },
          "tv": {
            "title": "Smart TV",
            "streaming": "Download and log into your favorite streaming services",
            "cast": "Cast from your phone via Chromecast"
          },
          "washer": {
            "title": "Washer and dryer",
            "free": "Free to use",
            "program": "Select desired program and relax",
            "water": "Remember to empty water container"
          },
          "ev": {
            "title": "Electric car",
            "body": "You can freely plug in your electric car. It might be turned off upon arrival."
          },
          "safety": {
            "title": "Safety",
            "sensors": "Sensors monitor open windows and doors.",
            "temp": "Temperature monitoring indoor, outdoor, sauna, pool and hot tub",
            "video": "Shed and annex are video monitored"
          }
        },
        "after": {
          "tidying": {
            "title": "Tidying up",
            "house": "Tidy the entire house and garden",
            "packed": "Double-check that you’ve packed everything"
          },
          "dishwasher": {
            "title": "Dishwasher",
            "body": "Wash and empty the dishwasher"
          },
          "espresso": {
            "title": "Espresso machine",
            "waste": "Empty coffee waste container",
            "water": "Empty water tank",
            "tray": "Empty drip tray"
          },
          "trash": {
            "title": "Trash",
            "sort": "Sort and dispose of trash in outdoor bins",
            "bottles": "Dispose of empty wine/spirit bottles in the waste container"
          },
          "lights": {
            "title": "Lights",
            "body": "Turn off all lighting, also outdoors"
          },
          "outdoor": {
            "title": "Outdoor furniture",
            "body": "Return outdoor furniture as found"
          },
          "grill": {
            "title": "Grill",
            "body": "Clean and cover grill after use"
          },
          "hotTub": {
            "title": "Hot tub",
            "body": "Leave the hot tub as it is after use. The water can stay in."
          },
          "activityRoom": {
            "title": "Activity room",
            "accessories": "Put all game accessories back in place.",
            "tabletop": "Put the table tennis/normal tabletop back on first, then place the tablecloth on top before leaving.",
            "chairs": "Fold the folding chairs and leave them as they were on arrival.",
            "fridge": "Empty the fridge of your own items.",
            "power": "Turn off projector, lights and equipment that should not stay on."
          },
          "lock": {
            "title": "Lock up",
            "windows": "Close all windows",
            "key": "Lock the door and leave the key in the key box"
          }
        }
      },
      "checkInOut": {
        "el": "Location of electricity meter",
        "elAlt": "Electricity meter location",
        "elLocation": "Location: To the right of the front door. Use flash for the picture.",
        "water": "Water meter location (house)",
        "waterAlt": "Water meter in house",
        "waterLocation": "Location: To the right in the utility closet. Open the sliding door in the entrance.",
        "poolWater": "Water meter location (pool)",
        "poolWaterAlt": "Water meter at pool",
        "poolWaterReadingAlt": "Pool water meter reading",
        "poolWaterLocation": "Location: In the shed, you'll find the water meter in the left corner. Be mindful of the pool equipment."
      },
      "practical": {
        "coffee": {
          "title": "Coffee machine",
          "body": "The coffee machine must be emptied of wastewater and coffee grounds regularly after use. Fill the tank with clean water. Coffee beans are included – refills are at your own expense.",
          "manual": "View manual here"
        },
        "sofa": {
          "title": "Sofa bed",
          "body": "How to use the sofa bed – watch the video below:",
          "fallback": "Your browser does not support the video."
        },
        "security": {
          "title": "Surveillance and alarms",
          "cameras": "Cameras monitor pool tech room, annex and shed",
          "shell": "Perimeter alarm covers all windows and doors, including external ones",
          "smoke": "Smoke and CO alarm notifies hosts if triggered",
          "temp": "Pool, hot tub, sauna and outdoor temperatures are monitored – visible on the screen by the TV"
        },
        "sonos": {
          "title": "Sonos speaker",
          "iphone": "iPhone: Use AirPlay and choose Sonos from speaker list.",
          "android": "Android: Use the Sonos app or Bluetooth if supported."
        },
        "stove": {
          "title": "Cooktop error",
          "body": "Note: If the cooktop displays “LO”, it means \"locked\". Hold the start button for 3 seconds to unlock."
        },
        "games": {
          "title": "Board games & Playstation",
          "cupboard": "Board games are in the cupboard above the fridge.",
          "purchases": "You’re welcome to play our games or download your own – but we don’t cover costs for guest purchases."
        }
      }
    },
    "checkInOutPage": {
      "title": "Check-in and out",
      "desktopTitle": "Check-in and Check-out",
      "description": "Mobile page for reading electricity and water meters",
      "mobileOnly": "– This page is only accessible via a mobile device",
      "unknownError": "Unknown error",
      "fallbackError": "Something went wrong.",
      "meterLocationPrompt": {
        "eyebrow": "Meter guide",
        "text": "Find the meters before entering your readings. We recommend tapping the upload button and taking each photo directly from there.",
        "button": "View locations"
      },
      "fields": {
        "name": {
          "label": "Name",
          "placeholder": "Renter name"
        },
        "keycode": {
          "label": "Keybox code",
          "placeholder": "Enter code"
        },
        "checkType": {
          "label": "Check-in or Check-out",
          "checkin": "Check-in",
          "checkout": "Check-out"
        },
        "confirmEmail": "Confirm email",
        "elReading": "Electricity meter reading",
        "elReadingDescription": "Use flash for the electricity meter photo so the numbers are clearly visible.",
        "waterHouse": "Water (house)",
        "waterHouseExamplePrefix": "Example:",
        "waterHouseExampleSuffix": ". The white numbers are before the comma, and the red numbers are after the comma.",
        "waterPool": "Water (pool)",
        "meterImages": {
          "label": "Reading photo",
          "description": "You can upload more than one photo. Verify each reading with clear photos, and use flash on the electricity meter."
        },
        "comment": {
          "label": "Comment",
          "placeholder": "Write your comment here"
        },
        "consent": "I consent to my information being used to process my request."
      },
      "submit": "Submit reading",
      "sending": "Uploading photos and sending the reading. This can take a moment...",
      "success": "Thanks! Your reading has been sent.",
      "progress": {
        "compressing": "Preparing photos",
        "ready": "Photos ready to upload",
        "readyOriginal": "Photos ready to upload",
        "originalSize": "Selected size: {{size}}",
        "uploading": "Uploading reading",
        "uploadSize": "Upload size: {{size}}"
      },
      "errors": {
        "rateLimited": "Too many readings were submitted in a short time. Please wait a moment and try again.",
        "tooFast": "Please review the form once more and send it again in a moment.",
        "formExpired": "This form session has expired. Please reload the page and send the reading again.",
        "invalidFileType": "Please upload image files only. Photos from your phone camera are accepted.",
        "fileTooLarge": "One or more photos are too large. Please open each meter photo, take a screenshot, and upload the screenshots instead.",
        "fileTooLargeInline": "This photo is too large. Please take a screenshot of it and add the screenshot instead.",
        "fileStillTooLargeInline": "This photo is still too large after preparation. Please take a screenshot of it and add the screenshot instead.",
        "totalUploadTooLarge": "The photos are too large. Please upload screenshots of the meter photos instead.",
        "tooManyFiles": "Too many photos were uploaded. Please upload only the meter photos needed for the reading.",
        "tooManyFields": "Too much information was submitted. Please reload the page and try again.",
        "missingFiles": "Please upload at least one photo of the meter reading.",
        "validation": "Please check the required fields and make sure the meter readings are filled in correctly.",
        "mail": "Your reading was recorded, but the email could not be sent automatically. We can still see it in the admin system.",
        "network": "The connection was interrupted before the reading could be sent. Please check your internet connection and try again.",
        "serverResponse": "The reading could not be sent because the server returned an unreadable error. Please try again with screenshots of the meter photos."
      },
      "errorLabel": "Error:",
      "errorTitle": "Reading could not be sent"
    },
    "manualPage": {
      "title": "Manual 🧭 Fyrrehaven 61",
      "description": "Important info for your stay: meter readings, access, house rules and more.",
      "imageAlt": "Manual image",
      "hero": {
        "title": "Thank you for choosing our summer house!",
        "subtitle": "We look forward to welcoming you in beautiful and relaxing surroundings – here’s a bit of practical info!"
      },
      "quickLinks": {
        "pool": "Pool",
        "hotTub": "Hot Tub",
        "sauna": "Sauna"
      },
      "notice": {
        "label": "NOTE!",
        "body": "It is your responsibility to read the electricity and water meters. If you forget this, you may be charged for more than your actual usage.",
        "meterLinkIntro": "Meter reading must be done at check-in and check-out via our website. You’ll find the QR code by the entrance or ",
        "meterLink": "here",
        "electricity": "Read the electricity meter",
        "houseWater": "Read water meter inside house",
        "poolWater": "Read pool water meter in shed"
      },
      "stayTitle": "Manual for your stay",
      "afterTitle": "After your stay"
    },
    "poolPage": {
      "seo": {
        "title": "Pool – May 2026",
        "description": "How to use and open the pool at the holiday home."
      },
      "title": "POOL",
      "subtitle": "– May 2026",
      "warning": {
        "title": "Swimming takes place with the pool cover closed on cold days to save electricity and heating",
        "body": "Please avoid leaving the entire pool cover open for a long time. The pool is accessible via the built-in door."
      },
      "rules": {
        "title": "Rules and use",
        "temperature": "Pool temperature is approx. 28 degrees Celsius",
        "depth": "1.5 meter deep",
        "automatic": "Pool is automatically filled with water and chemicals",
        "noDiving": "No diving",
        "tech": "All equipment is in the shed and can be controlled via app, please contact us if you have any issues!"
      },
      "preparation": {
        "title": "Preparation",
        "unlock": "Use the \"duck\" key to unlock the pool (see photos)",
        "open": "The pool cover can now be slid open or the door opened",
        "cover": "Remove pool cover and place it in the shed (can be folded or rolled up)"
      }
    },
    "activityRoomPage": {
      "seo": {
        "title": "Activity room – Fyrrehaven 61",
        "description": "Guide for using the activity room with billiards, table tennis, air hockey, darts, projector, fridge and safety rules."
      },
      "title": "Activity room",
      "subtitle": "Here you can play billiards, table tennis, air hockey and darts, or watch movies on the projector with Chromecast and Google TV. Folding chairs are available in the room for extra seating.",
      "fridge": {
        "title": "Fridge on arrival",
        "body": "The fridge must be turned on when you arrive. Use the switch next to the fridge and give it a little time to get cold."
      },
      "table": {
        "title": "Using the multi-game table",
        "intro": "The multi-game table is used for billiards, air hockey and table tennis. It is heavy, so change games slowly and carefully.",
        "howToTitle": "How to change game",
        "steps": [
          "Always remove balls, cues, bats, pucks and net from the table before changing game.",
          "The table has custom wheels with locks. If you move the table, lock all four wheels again before using it.",
          "Change between billiards and air hockey by unlocking the table brackets, turning the tabletop carefully and locking the brackets again before playing.",
          "For table tennis, place the table tennis plates on top of the table and attach the net in the middle.",
          "When using the table as a normal table, place the tablecloth on top first. Spills may otherwise reach and damage the game surface underneath.",
          "Only use the accessories that belong to the game, and put everything back after use."
        ],
        "wheelLockImageAlt": "Close-up of the lock on one of the multi-game table wheels",
        "wheelLockCaption": "There is a lock on each of the four wheels. Lock all wheels before playing.",
        "bracketsImageAlt": "Close-up of the red table brackets on the multi-game table",
        "bracketsCaption": "Open the table brackets before turning the tabletop, then lock them again before use.",
        "safetyTitle": "Usage and safety instructions",
        "safety": [
          "Only use the table when all four locking brackets are locked and supporting the table.",
          "Only use the table when all four wheel locks are locked.",
          "When turning the table, make sure all four locking brackets are fully open. If a bracket is closed, it may break.",
          "Always turn the table slowly and with as much care as possible.",
          "Never lean on the table and never sit on the edges.",
          "Always make sure the pool balls are out of the table and the air hockey power cable is pulled back before trying to turn the table.",
          "Children must always be accompanied by an adult when playing on or turning the table.",
          "Indoor use only."
        ]
      },
      "airHockey": {
        "title": "Air hockey",
        "steps": [
          "Plug the air hockey power cable into an outlet before playing.",
          "Only use the matching pucks and pushers.",
          "Unplug the power cable and pull it back before turning the table to another game."
        ]
      },
      "dart": {
        "title": "Darts",
        "steps": [
          "The dartboard is placed above the fridge.",
          "Only use darts at the dartboard.",
          "There are safety pads around the dartboard in case a dart misses the board. Still check the area around the board before throwing.",
          "Children may only play darts with an adult."
        ]
      },
      "projector": {
        "title": "Projector, Chromecast and Google TV",
        "steps": [
          "Turn on the projector.",
          "Turn on the soundbar manually if it is off. It lights red when it is off and connects automatically afterwards.",
          "Cast from your phone, or use Google TV to sign in to your own streaming service.",
          "Sign out of streaming services when you are done.",
          "Only turn off the projector before leaving the room. The soundbar turns off with the projector."
        ]
      },
      "closedArea": {
        "title": "Closed technical area",
        "body": "The area with the pool motor, chemicals and technical equipment is locked and must not be opened. The locked section is monitored by video."
      },
      "leaving": {
        "title": "Before leaving the room",
        "steps": [
          "Put all game accessories back in place.",
          "Put the table tennis/normal tabletop back on first, then place the tablecloth on top before leaving.",
          "Fold the folding chairs and leave them as they were on arrival.",
          "Empty the fridge of your own items.",
          "Turn off projector, lights and equipment that should not stay on."
        ]
      }
    },
    "welcome": {
      "title": "Welcome – Fyrrehaven 61",
      "hero": {
        "title": "Welcome to Fyrrehaven 61!",
        "subtitle": "We look forward to welcoming you in beautiful and relaxing surroundings – here’s a bit of practical info!"
      },
      "description": "Welcome to your stay at Fyrrehaven 61. Here you’ll find practical information about the house, pool, sauna, and much more.",
      "imageAlt": "Welcome image",
      "intro": "Here is a guide to your stay. Hopefully, it helps make your experience just right. If you can’t find your answers here or on the website, feel free to contact us.",
      "manualCta": "Go to the manual",
      "practicalInfoCta": "Practical information",
      "arrival": "When you arrive at Fyrrehaven 61, 8585 Glesborg, there is room for 6 cars in the driveway. You’ll also find an EV charger – if it’s unexpectedly turned off, check the website for how to turn it on.",
      "meterIntro": "First, take a photo of the electricity and water meters upon arrival – and again before departure – and send it to us for consumption billing.",
      "electricityMeter": "Electricity meter is located to the right of the front door under the covered terrace.",
      "waterMeters": "Water meters: One is in the technical cabinet in the entrance (used year-round), and another is near the pool system in the activity room (used only in pool season).",
      "keyBox": "The key box is to the right of the front door. The code is sent via email or Airbnb message 1 hour before arrival.",
      "guideIntro": "Important! Before using the pool, sauna, and hot tub, please read the guide:",
      "pool": "Pool",
      "sauna": "Sauna",
      "hotTub": "Hot Tub",
      "hotTubNote": "Note: You must not bring your own firewood for the hot tub as it is heated electrically.",
      "smoking": "Smoking is prohibited indoors. If you smoke outside, please pick up your cigarette butts.",
      "pets": "No pets allowed. Take care of our things and let us know if anything breaks.",
      "departureIntro": "Before departure, please follow the checklist on the website:",
      "departureCta": "Departure checklist",
      "hope": "We hope you have a unique and wonderful experience!",
      "share": "Feel free to share your experience using #fyrrehaven61 on social media.",
      "addressTitle": "Find the address here:",
      "mapAlt": "Map to the holiday home",
      "googleMaps": "Google Maps",
      "appleMaps": "Apple Maps"
    }
  },
  "navigation": {
    "public": {
      "house": "The House",
      "area": "Area",
      "gallery": "Gallery",
      "contact": "Contact"
    },
    "guest": {
      "welcome": "Welcome",
      "manual": "Manual",
      "activityRoom": "Activity room",
      "pool": "Pool",
      "sauna": "Sauna",
      "spa": "Hot Tub",
      "practicalInfo": "Practical Info"
    },
    "actions": {
      "book": "Book",
      "bookNow": "Book now",
      "changeAppearance": "Change appearance",
      "toggleAppearance": "Switch between light and dark mode",
      "changeLanguage": "Change language",
      "closeMenu": "Close menu",
      "openMenu": "Open menu",
      "currentLanguage": "Current language",
      "currentAppearance": "Current appearance"
    },
    "appearance": {
      "system": "System",
      "light": "Light",
      "dark": "Dark"
    },
    "menu": {
      "main": "Main navigation",
      "mobile": "Mobile menu",
      "title": "Menu",
      "description": "Main navigation for the page"
    }
  },
  "footer": {
    "tagline": "Holiday home by forest & beach",
    "superhostAria": "See our Airbnb profile (Superhost)",
    "sections": {
      "explore": "Explore",
      "contactBooking": "Contact & booking",
      "practical": "Practical"
    },
    "links": {
      "house": "The House",
      "area": "Area",
      "gallery": "Gallery",
      "bookAirbnb": "Book on Airbnb",
      "contact": "Contact us",
      "houseRules": "House rules",
      "faq": "Frequently asked questions",
      "activityRoom": "Activity room",
      "extraServices": "Extra services",
      "privacy": "Privacy",
      "cookies": "Cookie settings",
      "fees": "Fees"
    },
    "socialAria": "Social media",
    "messengerAria": "Message us on Messenger",
    "messengerDismissAria": "Hide Messenger button",
    "guestPageAria": "Guest page",
    "rights": "All rights reserved."
  },
  "seo": {
    "home": {
      "title": "Holiday Home Fjellerup | Fyrrehaven 61",
      "description": "Family holiday home on Djursland with a heated pool (May–Oct), hot tub, sauna and games room. Sleeps 10 near Fjellerup Beach and forest trails.",
      "keywords": [
        "Denmark holiday home",
        "holiday home Fjellerup",
        "Norway to Denmark holiday",
        "Germany to Denmark vacation",
        "family holiday Denmark",
        "heated pool holiday home",
        "hot tub rental",
        "sauna holiday home",
        "holiday home with activity room",
        "holiday home with billiards",
        "Djursland vacation rental",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Fyrrehaven 61 holiday home by Fjellerup Beach",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "house": {
      "title": "The House | Fyrrehaven 61",
      "description": "Holiday home for 10 in Denmark with an outdoor heated pool (May 1–Oct 1), electric hot tub, electric sauna and activity room with billiards, table tennis, air hockey, darts and projector. Family-friendly rental close to forest and beach.",
      "keywords": [
        "holiday home Fjellerup",
        "heated outdoor pool",
        "hot tub",
        "sauna",
        "activity room",
        "billiards",
        "air hockey",
        "family friendly",
        "sleeps 10",
        "Djursland vacation rental",
        "Fyrrehaven 61",
        "near beach and forest"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/IMG_3724.jpg",
      "imageAlt": "Outdoor pool area at the house",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "area": {
      "title": "Fjellerup Area | Fyrrehaven 61",
      "description": "Explore Fjellerup and Djursland from Fyrrehaven 61: forest trails at the doorstep, a beach within walking and biking distance, and family attractions like Djurs Sommerland, Mols Bjerge and the Kattegat Centre. See the map and our top local tips.",
      "keywords": [
        "Fjellerup",
        "Djursland",
        "forest and beach",
        "family attractions",
        "Djurs Sommerland",
        "Mols Bjerge",
        "Kattegat Centre",
        "Grenaa",
        "Ebeltoft",
        "hiking trails",
        "cycling routes",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Beach and forest at Fjellerup",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "gallery": {
      "title": "Gallery | Fyrrehaven 61",
      "description": "Browse photos of the living room, kitchen-diner, bedrooms, loft and activity room — plus the heated outdoor pool (May 1–Oct 1), electric hot tub, electric sauna and nearby forest and beach in Fjellerup. Get a true feel for the place.",
      "keywords": [
        "Fyrrehaven 61",
        "gallery",
        "holiday home photos",
        "heated outdoor pool",
        "hot tub",
        "sauna",
        "activity room",
        "Fjellerup",
        "Djursland",
        "forest and beach",
        "family holiday"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Gallery cover collage",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "faq": {
      "title": "FAQ | Fyrrehaven 61",
      "description": "Answers about check-in, pool & wellness, linens, payment, rules and more.",
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "FAQ about Fyrrehaven 61",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "contact": {
      "title": "Contact | Fyrrehaven 61",
      "description": "Got questions about dates, pricing, amenities or special requests? Send us a message — we usually reply the same day. All communication is handled by email and your data is processed under our privacy policy.",
      "keywords": [
        "contact",
        "Fyrrehaven 61",
        "holiday home Fjellerup",
        "booking questions",
        "holiday rental",
        "family friendly cottage",
        "pool hot tub sauna",
        "Djursland Denmark",
        "book direct",
        "Airbnb contact"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "The family behind the house",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "book": {
      "title": "Booking | Fyrrehaven 61",
      "description": "Book directly with the hosts or via Airbnb. Heated outdoor pool (May 1–Oct 1), activity room, sleeps 10 and family-friendly near forest and beach. We usually reply within 1 hour. Electricity 4 DKK/kWh and water 80 DKK/m³ are settled after your stay.",
      "keywords": [
        "holiday home booking",
        "Fyrrehaven 61 booking",
        "Fjellerup cottage",
        "heated outdoor pool",
        "hot tub",
        "sauna",
        "activity room",
        "family friendly rental",
        "book direct",
        "Airbnb Fjellerup",
        "Djursland holiday home"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Book the holiday home in Fjellerup",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "cookies": {
      "title": "Cookies | Fyrrehaven 61",
      "description": "Read about our use of cookies and manage your choices.",
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Cookies"
    },
    "fees": {
      "title": "Fees | Fyrrehaven 61",
      "description": "View the updated fee list for Fyrrehaven 61: booking rules, cleaning, late check-out and special cases. Electricity (4 DKK/kWh) and water (80 DKK/m³) are billed by usage. No parties or pets. Outdoor pool open May 1–Oct 1.",
      "keywords": [
        "holiday home fees",
        "fee list",
        "cleaning fee",
        "electricity usage price",
        "water usage price",
        "late check-out fee",
        "damage and charges",
        "Fyrrehaven 61 prices"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Fees overview",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "extraServices": {
      "title": "Extra Services | Fyrrehaven 61",
      "description": "See add-ons for your stay at Fyrrehaven 61: bed linen, sheets, towels, bundles, hot tub fill-up, high chair and baby cot.",
      "keywords": [
        "extra services",
        "holiday home add-ons",
        "bed linen holiday home",
        "towels holiday home",
        "hot tub fill-up",
        "baby cot",
        "high chair",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Extra services for the stay",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "privacy": {
      "title": "Privacy | Fyrrehaven 61",
      "description": "Learn how we process personal data when you contact us or book Fyrrehaven 61. We store enquiries as email with Simply, set only necessary cookies by default, and respect your GDPR rights.",
      "keywords": [
        "privacy policy",
        "GDPR",
        "personal data",
        "data processing",
        "data controller",
        "data processor",
        "GDPR rights",
        "cookie policy",
        "booking personal data",
        "Fyrrehaven 61 privacy",
        "email storage",
        "Simply email provider"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Privacy policy",
      "robots": {
        "index": false,
        "follow": true,
        "noarchive": true
      }
    }
  },
  "house": {
    "jsonLd": {
      "outdoorPool": "Outdoor heated pool",
      "poolSeason": "Open May 1 – Oct 1",
      "hotTub": "Electric hot tub",
      "sauna": "Electric sauna",
      "activityRoom": "Activity room with games and projector",
      "beachForest": "Near beach & forest"
    },
    "hero": {
      "title": "The House – sleeps 10, pool, wellness & activity room",
      "subtitle": "4 bedrooms + loft. Outdoor heated pool (May 1–Oct 1), electric hot tub, electric sauna and activity room.",
      "badges": [
        "10 guests",
        "4 bedrooms",
        "2 bathrooms",
        "Outdoor heated pool",
        "Hot tub",
        "Sauna",
        "Activity room"
      ],
      "primaryCta": "Book privately",
      "secondaryCta": "Book | Airbnb",
      "imageAlt": "Outdoor pool area at the house",
      "imageTitle": "Fyrrehaven 61 – holiday home by Fjellerup Beach"
    },
    "sleeping": {
      "title": "Sleeping arrangements & layout",
      "bedsTitle": "Beds (double)",
      "beds": [
        "4 double beds total: 2× 180×200 cm and 2× 200×200 cm",
        "Each double bed includes 2 pillows (fiber 60×63/70) and 2 fiber duvets 135×200"
      ],
      "storageTitle": "Linen & storage",
      "storage": [
        "Bed linen can be rented on request – otherwise bring your own",
        "Chest of drawers",
        "Mirror",
        "Hook behind the door",
        "2 bedside lamps"
      ]
    },
    "wellness": {
      "title": "Pool & wellness",
      "poolTitle": "Outdoor pool",
      "pool": [
        "1.5 m deep",
        "3.5 m wide · 8 m long",
        "Heated approx. 29 °C",
        "Season: May 1 – Oct 1",
        "Cover/roof can be closed on cold or windy days",
        "Pool lighting (switchable)",
        "Automatic chemical dosing"
      ],
      "hotTubTitle": "Electric hot tub",
      "hotTub": [
        "Up to 6 people",
        "Electric heating",
        "Massage jets and lighting",
        "Water is added via garden hose – can be pre-filled before arrival for an extra fee"
      ],
      "saunaTitle": "Sauna",
      "sauna": [
        "Up to 8 people",
        "Interior and exterior lights",
        "Gently pour water on the heater for steam"
      ]
    },
    "activityRoom": {
      "title": "Activity room",
      "gamesTitle": "Games in the room",
      "games": [
        "3-in-1 table for billiards, table tennis and air hockey",
        "Dartboard above the fridge with safety pads around it",
        "Air hockey uses power and must be plugged into an outlet before use"
      ],
      "movieTitle": "Movies & hangout",
      "movie": [
        "Projector with Chromecast and Google TV",
        "Bluetooth soundbar for movie audio",
        "Folding chairs and extra space for relaxed evenings"
      ]
    },
    "kitchenLiving": {
      "title": "Kitchen & living",
      "kitchenTitle": "Kitchen",
      "kitchen": [
        "Fully equipped kitchen: fridge/freezer, oven, microwave",
        "Automatic coffee machine, filter coffee and French press",
        "Waste sorting"
      ],
      "livingTitle": "Living & entertainment",
      "living": [
        "Large dining table seating 10",
        "Bright room with windows on both sides",
        "TV area with sofa, chairs and 55″ TV",
        "Outdoor slide",
        "Trampoline",
        "PlayStation 4"
      ]
    }
  },
  "facilities": {
    "aria": "Amenities",
    "title": "Amenities – full list",
    "intro": "Electricity and water are settled after your stay and paid by bank transfer.",
    "categories": {
      "kitchen": {
        "title": "Kitchen",
        "bullets": [
          "Fully equipped kitchen",
          "Fridge/freezer, oven and microwave",
          "Automatic coffee machine, filter & French press",
          "Sodastream incl. replaceable cartridge",
          "Tableware for 10: plates, cutlery, glasses, cups, champagne & wine glasses",
          "Water jugs and ice tray",
          "Waste sorting",
          "Gas grill"
        ]
      },
      "living": {
        "title": "Living & practical",
        "bullets": [
          "Large dining table for 10",
          "55\" TV and PlayStation 4 in the lounge",
          "Underfloor heating throughout · Air conditioning",
          "Washing machine and tumble dryer",
          "Travel cot (pre-book for free)",
          "Iron and hair dryer",
          "EV charger"
        ]
      },
      "activityRoom": {
        "title": "Activity room",
        "bullets": [
          "3-in-1 table for billiards, table tennis and air hockey",
          "Dartboard above the fridge with safety pads around it",
          "Projector with Chromecast, Google TV and Bluetooth soundbar",
          "Folding chairs and small fridge in the room"
        ]
      },
      "outdoor": {
        "title": "Outdoor",
        "bullets": [
          "Outdoor pool heated ~29°C (1 May – 1 Oct) with cover",
          "Electric hot tub (up to 6) with lights and massage",
          "Electric sauna (up to ~8) – light steam by pouring water on stones",
          "Trampoline and swing/play tower with slide"
        ]
      },
      "checkin": {
        "title": "Check-in",
        "bullets": [
          "Self check-in via key box (code sent 1 hour before arrival)",
          "Check-in 4:00 PM · Check-out 10:00 AM",
          "Upload photos of electricity & water meters on the website at check-in/out"
        ]
      },
      "rules": {
        "title": "House rules",
        "bullets": [
          "No parties",
          "No smoking indoors",
          "No access to annex and shed",
          "No access/stay in the pool utility room"
        ]
      }
    }
  },
  "cookiesPage": {
    "consent": {
      "brandName": "Fyrrehaven 61",
      "title": "We use cookies",
      "description": "We use necessary cookies to make the site work and remember your cookie settings.",
      "acceptAll": "OK",
      "rejectAll": "Reject all",
      "preferences": "Manage preferences",
      "settingsTitle": "Cookie settings",
      "close": "Close",
      "save": "Save preferences",
      "manageButton": "Manage cookie settings",
      "footer": "You can change or withdraw your consent at any time from the cookie settings."
    },
    "categories": {
      "necessary": {
        "title": "Necessary cookies",
        "label": "Necessary",
        "description": "Required for the site to function. These cookies cannot be disabled.",
        "tableCaption": "Necessary cookies"
      },
      "statistics": {
        "title": "Statistics cookies",
        "label": "Statistics",
        "description": "Optional analytics that help us understand how the site is used. They are only loaded if you allow them.",
        "tableCaption": "Statistics cookies"
      }
    },
    "preferences": {
      "introTitle": "Cookie settings",
      "introDescription": "Necessary cookies are always active because the website needs them to work. If we enable analytics, it only runs after you allow statistics cookies."
    },
    "table": {
      "name": "Name",
      "provider": "Provider",
      "purpose": "Purpose",
      "expiration": "Expiration",
      "type": "Type"
    },
    "page": {
      "title": "Cookies at Fyrrehaven 61",
      "intro": "Here you can read about our use of cookies and how to manage your preferences.",
      "typesTitle": "Types of cookies"
    }
  },
  "privacyPage": {
    "title": "Privacy Policy",
    "lead": "This notice explains how, as the data controller, we process personal data under the GDPR and applicable Danish law.",
    "controller": {
      "title": "Data Controller",
      "address": "Fyrrehaven 61, 8585 Glesborg, Denmark",
      "emailLabel": "Email",
      "phoneLabel": "Phone",
      "dpo": "We have not appointed a Data Protection Officer (DPO). Please contact us via the email above with any questions."
    },
    "sections": {
      "scope": {
        "title": "Scope and sources of data",
        "body": "This notice covers our website, contacting/booking via forms and ordering extras. Data originate primarily from you (forms/communications), from your device (technical logs) and in some cases from third-party platforms (e.g. Airbnb)."
      },
      "categories": {
        "title": "Categories of personal data",
        "items": [
          {
            "label": "Contact details",
            "text": "Name, email, phone, country."
          },
          {
            "label": "Booking data",
            "text": "Check-in/check-out, nights, number of guests (adults/children/babies), purpose of stay, accepted fees/prices."
          },
          {
            "label": "Extra services",
            "text": "Selected services and quantities (bedding, bed linen, towels, bundles, etc.)."
          },
          {
            "label": "Communications",
            "text": "Correspondence with you (e.g. emails)."
          },
          {
            "label": "Technical data",
            "text": "IP address, timestamps, URLs, device/browser information and similar basic logs for security purposes."
          },
          {
            "label": "Special categories",
            "text": "We do not process special-category data (art. 9)."
          }
        ]
      },
      "purposes": {
        "title": "Purposes and legal bases",
        "items": [
          {
            "label": "Enquiries and booking",
            "text": "Respond to enquiries, take steps to enter into/perform a rental agreement and deliver services (art. 6(1)(b))."
          },
          {
            "label": "Accounting and legal duties",
            "text": "Compliance with legal obligations (art. 6(1)(c))."
          },
          {
            "label": "Security and operations",
            "text": "IT security, abuse prevention, troubleshooting (legitimate interests; art. 6(1)(f))."
          },
          {
            "label": "Marketing",
            "text": "Only with consent (art. 6(1)(a))."
          }
        ]
      },
      "necessity": {
        "title": "Is provision of data required?",
        "body": "Where we request information, it is to respond to your enquiry or to enter into/administer a booking. Without the information we may be unable to deliver the requested service."
      },
      "recipients": {
        "title": "Recipients and international transfers",
        "body": "We use trusted processors for operations and communications (e.g. hosting, email and security). They process data only on our instructions under appropriate data-processing agreements. Where data are transferred outside the EU/EEA we rely on valid transfer mechanisms (typically the EU Standard Contractual Clauses, SCCs).",
        "items": [
          {
            "label": "Email",
            "text": "Form submissions are delivered as emails to our mailbox with Simply (email provider)."
          },
          {
            "label": "Third-party platforms",
            "text": "When you use links to e.g. Airbnb or social media, they act as independent controllers for their processing."
          }
        ]
      },
      "storage": {
        "title": "Storage and access to data",
        "paragraphs": [
          "We do not store your data in a separate database. All information you submit through our forms is sent and stored as email in our mailbox with Simply. We only access personal data via Simply’s email client/webmail.",
          "Email transmission generally uses TLS where supported by the receiving server."
        ]
      },
      "retention": {
        "title": "Retention periods",
        "items": [
          "Enquiries (in the inbox): normally up to 12 months, unless the correspondence forms part of a booking or legal claim.",
          "Booking and accounting data in email/attachments: generally 5 years for accounting rules.",
          "Security/access logs: typically 6 months."
        ]
      },
      "cookies": {
        "title": "Cookies and similar technologies",
        "body": "We use technically necessary cookies/storage to deliver the site securely and remember your cookie settings. Optional analytics will only run if you actively allow statistics cookies."
      },
      "rights": {
        "title": "Your rights",
        "items": [
          "Access (art. 15)",
          "Rectification (art. 16)",
          "Erasure (art. 17)",
          "Restriction (art. 18)",
          "Data portability (art. 20)",
          "Object to processing (art. 21)",
          "Withdraw consent (art. 7(3)) — without affecting lawfulness prior to withdrawal."
        ],
        "paragraphs": [
          "Email us at the address above to exercise your rights. We normally respond within 1 month and may request identification.",
          "You may lodge a complaint with the Danish Data Protection Agency: www.datatilsynet.dk."
        ]
      },
      "automated": {
        "title": "Automated decision-making",
        "body": "We do not carry out automated decision-making or profiling producing legal effects or similarly significant impacts (art. 22)."
      },
      "changes": {
        "title": "Changes to this notice",
        "body": "We update this notice when our processing changes or when required by law. Material changes will be announced here.",
        "updatedLabel": "Last updated",
        "updated": "16 September 2025"
      },
      "contact": {
        "title": "Contact",
        "body": "If you have any questions about this privacy policy, please contact us."
      }
    }
  }
} as const;
